class APIS {
	apis() {
		return {
			monthlyMau: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/get/monthly'
			},
			monthlyMauSuper: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/getall/monthly'
			},
			initialMonthlyMauSuper: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/info/boxes'
			},
			chatChartInOutCC: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/chat/stats'
			},
			chatChartEngagments: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/engagement/stats'
			},
			chatReport: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/chat/report'
			},

			agentChart: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/conversation'
			},
			agentReport: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/report'
			},
			agentPerformanceReport: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/performance/report'
			},
			agentAverageTime: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/averagetime'
			},

			campaignChart: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: '/campaign/stats'
			},
			campaignReport: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/campaign/records'
			},

			broadcastChart: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: 'campaign/stats'
			},
			broadcastreport: {
				headers: {
					'xt-user-token': null
				},
				method: 'get',
				path: 'campaign/report'
			},
			autoreply_report: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/autoreplies/report'
			},

			autoMessgeCount: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/count/menu'
			},
			userMessageReportCount: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/fetch/count/report'
			},
			agentStats: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/agent/allstats'
			},

			monthlyusersTable: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/monthly/users'
			},

			templateReports: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/user/template/report'
			},
			callHistory: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/calls/list'
			},
			chatKpi: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/chat/kpi'
			}
		};
	}
}

export default new APIS();
